// extracted by mini-css-extract-plugin
module.exports = {"sendButton":"MessageFormSendButton_sendButton__3OcRQ","sendButtonContainer":"MessageFormSendButton_sendButtonContainer__2bRTc","disabled":"MessageFormSendButton_disabled__218f2"};